module.exports = __webpack_public_path__ + "img/photo-0044.03bf1ffa.jpg";